import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-personalized-email-notification',
  templateUrl: './customer-personalized-email-notification.component.html',
  styleUrls: ['./customer-personalized-email-notification.component.css']
})
export class CustomerPersonalizedEmailNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
